import './styles.scss';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AddressItem } from './Address';
import {
  MinusIcon,
  GreaterThanIcon,
  PlusIcon,
} from '@global/components/UI Elements/Icons';
import { Address } from '@global/types/types';

type AddressProps = {
  addresses: Address[];
  selectedAddressUid: string | null;
  selectAddress: (value: string) => void;
  editAddress: (value: string) => void;
  createNewAddress: () => void;
  isHidden?: boolean;
};

export const Addresses = ({
  selectedAddressUid,
  selectAddress,
  editAddress,
  addresses,
  createNewAddress,
  isHidden = false,
}: AddressProps) => {
  const { t } = useTranslation('', { keyPrefix: 'checkout.savedAddress' });

  const [isShowMore, setIsShowMore] = useState(false);

  const toggleShowMore = () => setIsShowMore((prevState) => !prevState);

  if (addresses.length === 0 || isHidden) {
    return <div className="addresses"></div>;
  }

  return (
    <div className="addresses">
      <span className="addresses__title">{t('useSavedAddress')}</span>
      <ul className="addresses__list">
        {addresses.map((address, index) =>
          (!isShowMore && index < 2) || isShowMore ? (
            <li key={address.uid}>
              <AddressItem
                address={address}
                onSelect={() => selectAddress(address.uid)}
                isSelected={selectedAddressUid === address.uid}
              />
              <button
                className="checkout__edit-btn"
                onClick={() => editAddress(address.uid)}
              >
                {t('editBtn')}
              </button>
            </li>
          ) : null
        )}
      </ul>
      <div className="addresses__buttons">
        {isShowMore && addresses.length > 2 && (
          <button className="green-button" onClick={toggleShowMore}>
            {t('lessBtn')}
            <span className="green-button__icon">
              <MinusIcon />
            </span>
          </button>
        )}
        {!isShowMore && addresses.length > 2 && (
          <button className="green-button" onClick={toggleShowMore}>
            {t('moreBtn')}
            <span className="green-button__icon">
              <PlusIcon />
            </span>
          </button>
        )}
        <button className="green-button" onClick={createNewAddress}>
          {t('newAddressBtn')}
          <span className="green-button__icon">
            <GreaterThanIcon />
          </span>
        </button>
      </div>
    </div>
  );
};
